import Vue from 'vue';
import Vuex from 'vuex';
import * as request from '@/request/common';
import storage from 'store';
import asidebar from './modules/asidebar';
Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        userInfo: {}, // 用户信息
        cityList: [], // 城市列表
        allSubjectList: [], // 全部学科
        meetingInfo: null, // 会议基本信息
        downNumber: 0 // 获取正在下载数量
    },
    getters: {
        userInfo: state => state.userInfo,
        cityList: state => state.cityList,
        meetingInfo: state => state.meetingInfo,
        allSubjectList: state => state.allSubjectList,
        downNumber: state => state.downNumber,
        m_base_url: state => {
            let { m_committee_id, domain_url } = state.meetingInfo;
            let base_url = m_committee_id == 2 ? '.scimeeting.cn' : '.sciconf.cn';
            return `https://${domain_url || 'mm'}${base_url}`;
        }
    },
    mutations: {
        /**
         * 更新属性值的方法
         * @param {Object} state
         * @param {Object} o 要更新的对象 例如{userInfo:{name:'1111'}}
         * 如果更新模块下的state属性时,请使用  模块名.属性名 例如模块index的name {'index.name':'aaa'}
         **/
        updateState(state, o) {
            for (let key in o) {
                let saveKey = '';
                let keyArr = key.split('.');
                let l = keyArr.length;
                if (l >= 2) {
                    // 使用本地存储时，保存的键名
                    saveKey = keyArr[0];
                    // 多级更新字段时，需要遍历找到state内对应字段的属性（子元素，例如：a.b.c.d 需要遍历找到 state内a属性的d元素）
                    let obj = state[saveKey];
                    for (let i = 1; i < l - 1; i++) {
                        obj = obj[keyArr[i]];
                    }
                    // 取最终要更新的字段名
                    let k = keyArr[l - 1];
                    // 更新state对应字段
                    obj[k] = o[key];
                } else {
                    // 更新state对应字段
                    state[key] = o[key];
                }
            }
        }
    },
    actions: {
        // 获取会议信息
        getMeetingInfo({ state }, headers) {
            headers['mid'] = headers['meetingID'];
            return new Promise((resolve, reject) => {
                if (!state.meetingInfo) {
                    request
                        .post({
                            url: 'getMeetingInfo',
                            headers,
                            costom: {
                                errorCallback: () => {
                                    // 出错后退出浏览器
                                    storage.set('auth', '');
                                    // 关闭浏览器
                                    var userAgent = navigator.userAgent;
                                    if (userAgent.indexOf('Firefox') != -1 || userAgent.indexOf('Presto') != -1) {
                                        window.location.replace('about:blank');
                                    } else {
                                        window.opener = null;
                                        window.open('', '_self');
                                        window.close();
                                    }
                                }
                            }
                        })
                        .then(res => {
                            //   console.log(res);
                            state.meetingInfo = res.data;
                            resolve(state.meetingInfo);
                        })
                        .catch(err => {
                            reject(err);
                        });
                } else {
                    resolve(state.meetingInfo);
                }
            });
        },

        // 获取省市区
        getAddress({ state }) {
            let cityList = [];
            return new Promise(resolve => {
                if (state.cityList.length) {
                    resolve(state.cityList);
                } else {
                    request
                        .get({ url: 'address', costom: { hideModal: true } })
                        .then(res => {
                            if (res && res.indexOf('layui.define(function(exports){') > -1) {
                                let a = res.split('var addressList = ')[1];
                                a = a.replace(/^\s+|\s+$/g, '');
                                a = a.split("exports('cityJson',addressList);")[0];
                                a = a.replace(/\ /g, '').replace(';', '');
                                cityList = JSON.parse(a);
                                state.cityList = cityList;
                                resolve(cityList);
                            }
                        })
                        .catch(res => {
                            console.log(res);
                            resolve(cityList);
                        });
                }
            });
        },

        // 获取所有学科列表
        getAllSubjectList({ state }) {
            let allSubjectList = [];
            return new Promise(resolve => {
                if (state.allSubjectList.length) {
                    resolve(state.allSubjectList);
                } else {
                    let { m_committee_id } = state?.meetingInfo || {};
                    request
                        .post({ url: 'getVideoSubjectList', data: { committee_id: m_committee_id }, costom: { hideModal: true } })
                        .then(res => {
                            state.allSubjectList = res.data;
                            resolve(res.data);
                        })
                        .catch(err => {
                            console.log(err);
                            resolve(allSubjectList);
                        });
                }
            });
        },

        // 获取正在下载数量
        getNowDownNumber({ state }) {
            request
                .post({ url: 'getDownNumber' })
                .then(res => {
                    state.downNumber = res.data?.count || 0;
                })
                .catch(err => {
                    console.log(err);
                });
        }
    },
    modules: {
        asidebar
    }
});
